import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import isArray from 'lodash/isArray';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CloseAlert, selectAlert, selectAlertLoading } from '../../redux/reducers/AlertReducer';
import StyledModal from '../StyledModal';
import { AlertIcon } from './AlertIcon';
import { AlertTitle } from './AlertTitle';

// -----------------------------------------------------------------------------------------------

export function SimpleAlert() {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const loading = useSelector(selectAlertLoading);
  const { status, text, msg, code, errors, translationValues, contactManager } = useSelector(selectAlert);

  const handleClose = () => dispatch(CloseAlert());

  const isOpen = loading === 'succeeded' || loading === 'pending';
  const isFail = status === 'fail' || status === 'error';

  if (!isOpen) {
    return null;
  }

  let serverErrorText;
  if (text) {
    serverErrorText = text;
  } else if (code) {
    serverErrorText = t(code);
  } else if (msg) {
    serverErrorText = t(`alert.codes.${msg}`, translationValues);
  } else {
    serverErrorText = t('alert.serverError');
  }

  return (
    <StyledModal
      maxWidth={'xs'}
      open={isOpen}
      handleClose={handleClose}
      hideCloseButton
      sx={{ zIndex: '1350 !important' }}
    >
      <Box display={'flex'} alignItems={'center'} justifyContent={'center'} flexDirection={'column'}>
        {loading === 'pending' && <CircularProgress />}
        {loading === 'succeeded' && (
          <>
            {/* Alert Title */}
            <AlertTitle status={status} />

            {/* Alert Icon */}
            <AlertIcon isFail={isFail} sx={{ mb: 2 }} />

            {/* Alert Message */}
            {isArray(text) ? (
              text.map((item) => (
                <Typography
                  key={`${item}`}
                  color={'text.primary'}
                  align={'center'}
                  component={'div'}
                  sx={{ wordBreak: 'break-word' }}
                >
                  {item}
                </Typography>
              ))
            ) : (
              <Typography color={'text.primary'} align={'center'} component={'div'} sx={{ wordBreak: 'break-word' }}>
                {serverErrorText}
              </Typography>
            )}

            {errors &&
              isArray(errors) &&
              errors.map((error) => (
                <Typography
                  variant={'h4'}
                  key={`${error}`}
                  color={'error'}
                  align={'center'}
                  component={'div'}
                  sx={{ wordBreak: 'break-word' }}
                >
                  {error}
                </Typography>
              ))}

            {/* Alert Conact Manager/Admin */}
            {isFail && (
              <Typography
                variant={'body2'}
                id="alert-description"
                sx={{ mt: 1 }}
                color={'text.secondary'}
                align={'center'}
              >
                {contactManager ? t('alert.contactManager') : t('alert.contactAdmin')}
              </Typography>
            )}
          </>
        )}
      </Box>
    </StyledModal>
  );
}
